export function getCookieValue(value: string): string {
  const re = new RegExp(`(?:(?:^|.*;\\s*)${value}\\s*\\=\\s*([^;]*).*$)|^.*$`)
  return decodeURIComponent(document.cookie.replace(re, '$1'))
}

export const joyfullyBoldEnabled = () => {
  const cookie = getCookieValue('JL_Joyfully_Bold')
  if (cookie === '') return false
  if (cookie) return cookie !== 'false'
  return true
}

export const getIsDebugTestingActive = () => {
  const cookie = getCookieValue('JL_Digital_Conversations_Testing')
  if (cookie === '') return false
  if (cookie) return cookie !== 'false'
  return true
}

export const userGreetingIsEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const dispatchOmnitureEvent = (name: string, detail: unknown) => {
  document.body.dispatchEvent(new CustomEvent(name, { detail }))
}

export const reShowChatAvatar = () => {
  const embeddedServiceIcon = document.getElementsByClassName('embeddedServiceIcon')?.[0] as HTMLElement | undefined
  // This check is for the edge case of lost network during the loading text message UI defect caused
  const chatText = document.querySelector('.embeddedServiceHelpButton .message')
  if (embeddedServiceIcon && chatText?.innerHTML === 'Chat') {
    embeddedServiceIcon.style.display = 'inline-block'
  }
}

export const addToMonitoredChatArrayIfUnique = (arr: string[], item: string) => {
  if (arr.indexOf(item) === -1) {
    const newMonitoredChatArray = arr.concat(item)
    localStorage.setItem('chatTransferJourney', JSON.stringify(newMonitoredChatArray))

    return newMonitoredChatArray
  }
  return arr
}
